module.exports = __webpack_public_path__ + "img/22.e716df66.jpg";